// extracted by mini-css-extract-plugin
module.exports = {"tabs":"style__tabs__jCeSN","vertical":"style__vertical__QYV58","tabsLeft":"style__tabsLeft__Ly3Iw"};